<script setup lang="ts">
import { useVocabularyStore } from '@/stores/vocabulary'

const vocabularyStore = useVocabularyStore()
</script>

<template>
  <div class="fixed bottom-4 right-4 z-50">
    <!-- 复习按钮（始终显示，允许随时进入复习） -->
    <button
      @click="$router.push('/review')"
      class="relative px-6 py-3 bg-primary-600 text-white rounded-full shadow-lg hover:bg-primary-700 hover:shadow-xl transition-all duration-200"
    >
      <span class="mr-2">📚</span>
      <span>复习生词</span>
      <span
        v-if="vocabularyStore.stats.todayReview > 0"
        class="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white text-xs rounded-full flex items-center justify-center"
      >
        {{ vocabularyStore.stats.todayReview }}
      </span>
    </button>
  </div>
</template>
